export default __webpack_public_path__ + "static/media/Socreates+Privacy+Policy.ee672f41.gif";